<template>
  <div class="home-main">
    <global-home></global-home>
  </div>
</template>
<script>
import globalHome from '@/pages/views/home/home';
export default {
  components: {
    globalHome
  },
  created() {
    // if (!localStorage.get('userInfo')) {
    //   localStorage.set('userInfo', {});
    // }
  }
};
</script>
<style scoped>
.home-main {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: -10;
}
</style>



// WEBPACK FOOTER //
// src/common/area/home.vue